import { render } from "./ConsolidatedReportDetailsDialog.vue?vue&type=template&id=495122d1"
import script from "./ConsolidatedReportDetailsDialog.vue?vue&type=script&lang=js"
export * from "./ConsolidatedReportDetailsDialog.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__